import React, { useMemo } from 'react'

import { StyledText, Popover } from '@clickcease/cc-client-components-lib'
import { useGetUserAccounts } from './api/getUserAccounts'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { SelectWrapper, UserMenuStyled } from './AccountSelector.styled'
import { UserAccount } from 'Types/UserAccount'
import { UserMenuOption, UserMenuTrigger } from 'Components/Elements/UserMenu/UserMenu.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { useLoginUser } from 'Features/auth/hooks/login'
import { useNavigate } from 'react-router-dom'
import { useGetReactivationAccounts } from 'Features/ReactivationPage/api/getReactivationAccounts'

export const AccountSelector = () => {
  const { data: accounts } = useGetUserAccounts()
  const { accountId, origin, setOrigin } = useUserStore()
  const { data: accountsToReactivate } = useGetReactivationAccounts()
  const { switchAccount } = useLoginUser()
  const navigate = useNavigate()
  const unsortedAccounts = accounts?.accounts

  if (!origin && accounts?.accounts.length) {
    setOrigin(accounts?.accounts[0].origin || '')
  }

  const accountsOptions = useMemo(() => {
    // move current accountId to the top of the list
    const orderedAccounts = [...unsortedAccounts].sort((a, b) => {
      if (a.accountId === accountId) {
        return -1
      }
      if (b.accountId === accountId) {
        return 1
      }
      return 0
    })

    return typeof orderedAccounts === 'undefined'
      ? []
      : orderedAccounts.map((account) => ({
          label: ('accountName' in account && account.accountName) || account.accountId,
          value: account.accountId,
        }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts, accountId])

  const onAccountChange = (id: number) => {
    const account = unsortedAccounts.find((account: UserAccount) => account.accountId == id)
    const accountToReactivate = accountsToReactivate?.find((account) => account.id === id)
    if (!account?.activeSubscription && (accountToReactivate?.subscriptions?.length || 0) > 0) {
      navigate('/reactivation')
    } else {
      switchAccount(account)
    }
  }

  const getAccountName = () => {
    const account = unsortedAccounts.find((account) => account.accountId == accountId)
    return !!account && 'accountName' in account ? account.accountName : accountId.toString()
  }

  return (
    <SelectWrapper>
      {unsortedAccounts.length <= 1 && (
        <UserMenuTrigger singleAccount>
          <StyledText variant={'baseLight'}>{getAccountName()}</StyledText>
        </UserMenuTrigger>
      )}
      {unsortedAccounts.length > 1 && (
        <Popover
          style={{ zIndex: 1 }}
          trigger={
            <UserMenuTrigger>
              <StyledText variant={'baseLight'}>{getAccountName()}</StyledText>
              <FontAwesomeIcon icon={faChevronDown as IconProp} width="10px" />
            </UserMenuTrigger>
          }
          content={
            <UserMenuStyled>
              {accountsOptions.map((option) => (
                <UserMenuOption
                  key={`${option.label}-${option.value}`}
                  onClick={() => onAccountChange(option.value)}
                >
                  {option.label}
                </UserMenuOption>
              ))}
            </UserMenuStyled>
          }
        />
      )}
    </SelectWrapper>
  )
}
